<template>
  <!--  -->
  <div class="side-panel left com-left hf osy ml-30">
    <div class="side-panel-bg">
      <div class="pt-20 pl-20 pb-5 pr-20 thisMonthData">
        <h1 class="f-20 c-satwo">
          <span>能源使用合规监测 <img src="/imgs/complianceTitleIcon.png" class="ml-10"></span>
        </h1>
        <h3 class="f-14 pt-20 c-satwotitle">实时能耗监测</h3>
        <div class="fr ov bleftOne">
          <chart-bar-energy chartTitle="实时能耗监测" :chartData='energyMonitoring' style="width: 100%; height: 220px;" />
        </div>
        <h3 class="f-14 pt-20 c-satwotitle">历史PUE数据</h3>
        <div class="fr ov bleftOne">
          <chart-line-pue-hist chartTitle="历史PUE数据" :chartData='pueHistory' style="width: 100%; height: 220px;" />
        </div>
      </div>

      <div class="pt-20 pl-20 pb-5 pr-20  thisMonthData">
        <h1 class="f-20 c-satwo">
          <span>算力使用合规监测 <img src="/imgs/complianceTitleIcon.png" class="ml-10"></span>
        </h1>
        <div class="data-bar comCenterTxt mt-15" style="vertical-align: bottom;">
          <div class="data-item mr-25">
            <span class="di-name">告警: </span>
            <span class="di-value" style="color: #FF0000;">{{ irrUsageCount.alarm }}</span>
          </div>
          <div class="data-item mr-25">
            <div class="di-name">已确认: </div>
            <div class="di-value mr-5" style="color:#2CC2B7;">
              {{ irrUsageCount.event }}&nbsp;
              <span class="di-unit" style="color: #1a7b7a;">事件</span>
              &nbsp;/&nbsp;
            </div>
            <span class="di-value mr-5" style="color:#2CC2B7;">{{ irrUsageCount.processed }}</span>
            <span class="di-unit" style="color: #1a7b7a;">已处置</span>
            <span class="di-value mr-5" style="color:#2CC2B7;">&nbsp;/&nbsp;</span>
            <span class="di-value" style="color:#1a7b7a;">
              {{ irrUsageCount.false_alarm }}&nbsp;
              <span class="di-unit" style="color: #1a7b7a;">误报</span>
            </span>
          </div>
          <div class="data-item">
            <span class="di-name">未确认: </span>
            <span class="di-value" style="color: #0280a2;">{{ irrUsageCount.untreated }}</span>
          </div>
        </div>
        <h3 class="f-14 pt-20 c-satwotitle">合规性告警趋势</h3>
        <div class="fr ov bleftOne">
          <chart-line-irrusage-hist chartTitle="合规性事件趋势" :chartData='irrUsageHistory' style="width: 100%; height: 210px;"></chart-line-irrusage-hist>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chartBarEnergy from './chart-bar-energy'
import chartLinePueHist from "./chart-line-pue-hist.vue"
import chartLineIrrusageHist from "./chart-line-irrusage-hist.vue";

export default {
  name: 'com-left',
  components: {
    chartBarEnergy,
    chartLinePueHist,
    chartLineIrrusageHist,
  },
  props: {
    resData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      energyMonitoring: {},
      pueHistory: {},
      irrUsageCount: {},
      irrUsageHistory: {},
    }
  },
  mounted () {
    this.$nextTick(function () {
      // 初始化dom相关数据
      setTimeout(()=>{
        this.energyMonitoring = this.resData.energyMonitoring
        this.pueHistory = this.resData.pueHistory
        this.irrUsageCount = this.resData.irrUsageCount
        this.irrUsageHistory = this.resData.irrUsageHistory
      },300)
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.side-panel-bg{
  background: rgba(0,0,0,0) !important;
}
.thisMonthData {
  .bleftOne > div {
    background: url(/imgs/border-leftOne.png) no-repeat;
    width: 120px;
    height: 69px;
    background-size: 100% 69px;
  }

  .bleftTwo > div {
    background: url(/imgs/border-leftTwo.png) no-repeat;
    height: 68px;
    background-size: 100%;
  }
}

.bleftThree {
  background: url(/imgs/border-leftThree.png) no-repeat;
  height: 225px;
  background-size: 100%;
  padding: 5px 0;
}

.data-bar {
  display: flex;
  align-items: center;
  justify-content: center;
}
.data-item {
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
}
.di-name {
  color: #d4d8da;
  font-size: 11px;
  line-height: 11px;
  vertical-align: bottom;
  margin-right: 5px;
}
.di-value {
  font-size: 18px;
  line-height: 16px;
  font-weight: bold;
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
}
.di-unit {
  font-size: 10px;
  line-height: 10px;
  vertical-align: bottom;
}

.c-satwo{
  background: url(/imgs/complianceTitle.png) no-repeat;
  height: 40px;
  
}
.c-satwo span{
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 0;
  font-weight: 400;
  padding-left: 37px;
  line-height: 40px;
}
</style>
